import Image from 'next/image';
import TextMedia, { TextMediaProps } from '@/components/_rebrand/TextMedia';
import SerifAndSansSerifHeadline, { HeadlineFromCraftProps } from '@/components/_rebrand/craft/product/_organisms/SerifAndSansSerifHeadline';

const displayProps = {
  title: '',
  features: [],
  alternateFeatures: false,
} as TextMediaProps;

interface FeatureBulletFromCraft {
  bulletText: string;
}

interface FeatureImageFromCraft {
  url: string;
  title: string;
  width: number;
  height: number;
}

interface FeatureFromCraft {
  bullets: FeatureBulletFromCraft[];
  headline: string;
  image: FeatureImageFromCraft;
}

interface ModuleProductFeatures {
  header: HeadlineFromCraftProps ;
  featuresToDisplay: FeatureFromCraft[];
  alternateFeatureDisplayRightLeftRightLeft: boolean
}

const formBulletArray = (bullets: FeatureBulletFromCraft[]): TextMediaProps['features'][number]['bullets'] => {
  const bulletsArray: TextMediaProps['features'][number]['bullets'] = bullets.map((bullet: FeatureBulletFromCraft) => ({
    feature: bullet.bulletText
    }));

  return bulletsArray;
}

const formImageTag = (image: FeatureImageFromCraft): TextMediaProps['features'][number]['featureImage'] => {
  const data = Array.isArray(image) ? image[0] : image;

  return <Image src={data.url} width={data.width} height={data.width} alt={data.title} />
}

const formFeatureList = (features: FeatureFromCraft[]): TextMediaProps['features'] => {
  const featureList: TextMediaProps['features'] = features.map((feature) => ({
      title: feature.headline,
      featureImage: formImageTag(feature.image),
      bullets: formBulletArray(feature.bullets)
  }));

  return featureList;
}

const setDynamicDisplayPropAttributes = (data: ModuleProductFeatures) => {
  displayProps.title = <SerifAndSansSerifHeadline {...data.header[0]} />
  displayProps.features = formFeatureList(data.featuresToDisplay);
  displayProps.alternateFeatures = data.alternateFeatureDisplayRightLeftRightLeft;
};

const Features = ({ entry }) => {
  const data = Array.isArray(entry?.moduleProductFeatures)
    ? entry.moduleProductFeatures[0]
    : entry?.moduleProductFeatures;

  setDynamicDisplayPropAttributes(data);

  return (
    <TextMedia {...displayProps} />
  );
};

export default Features;

